import React, { useState } from 'react';
import { List, Typography } from "@mui/material";
import InvoiceReport from '../../components/reports/modals/InvoiceReport';
import MedicalHistoryReport from '../../components/reports/modals/MedicalHistoryReport';
import AppointmentReport from '../../components/reports/modals/AppointmentReport';
import InventoryReport from '../../components/reports/modals/InventoryReport';
import RequirePermission from '../../components/RequirePermission';
import { SUB_MODULES } from '../../constants/subModulesConstants';

const ReportsPage = () => {
    // const [type, setType] = useState([]);

    return (
        <>
            <Typography variant="h4">Reports</Typography>
            <List>
              <RequirePermission subModuleName={SUB_MODULES.MEDICAL_HISTORY_REPORT} minAccessLevel={1}>
                <MedicalHistoryReport />
              </RequirePermission>
              <RequirePermission subModuleName={SUB_MODULES.APPOINTMENTS_REPORT} minAccessLevel={1}>
                <AppointmentReport />
              </RequirePermission>
              <RequirePermission subModuleName={SUB_MODULES.REVENUE_REPORT} minAccessLevel={1}>
                <InvoiceReport />
              </RequirePermission>
              <RequirePermission subModuleName={SUB_MODULES.INVENTORY_REPORT} minAccessLevel={1}>
                <InventoryReport />
              </RequirePermission>
            </List>
        </>
    );
};

export default ReportsPage;
